module.exports = __webpack_public_path__ + "media/svg-new/support-pink-3-3b8e1348.svg";